<template>
<div class="chapter">
<div class="inner_page">
<p class="GillSans-Bold2" style="text-align:center">Michael—This one’s for you.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CTH_06.vue?cbe395c2